<div *ngIf="data">
  <h2 mat-dialog-title style="text-align: center">{{ data.title }}</h2>
  <mat-dialog-content class="mat-typography">
    <div *ngIf="data.wait" fxLayout="row" fxLayoutAlign="space-around center" style="text-align: center">
      <mat-spinner [diameter]="75"></mat-spinner>
    </div>
    <div *ngIf="data.option == -1 && data.id == -1" id="">
      <div style="
          width: 100%;
          padding: 10px;
          border: 1px dashed #efefef;
          margin-bottom: 10px;
        ">
        <form>
          <mat-form-field appearance="fill" style="width: 100%">
            <mat-label>Identificador de Campaña</mat-label>
            <input matInput />
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%">
            <mat-label>Fecha de Inicio</mat-label>
            <input matInput [matDatepicker]="picker1" />
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%">
            <mat-label>Fecha de Finalización</mat-label>
            <input matInput [matDatepicker]="picker2" />
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
        </form>
      </div>
    </div>
    <div *ngIf="data.option == 0 && data.id != -1" id="">
      <div style="
          width: 100%;
          padding: 10px;
          border: 1px dashed #efefef;
          margin-bottom: 10px;
        ">
        <form>
          <mat-form-field appearance="fill" style="width: 100%">
            <mat-label>Identificador de Campaña</mat-label>
            <input matInput [value]="data.element.uuid" />
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%">
            <mat-label>Fecha de Inicio</mat-label>
            <input matInput [matDatepicker]="picker1" [value]="doTransformDate(data.element.start)" />
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%">
            <mat-label>Fecha de Finalización</mat-label>
            <input matInput [matDatepicker]="picker2" [value]="doTransformDate(data.element.end)" />
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
        </form>
      </div>
    </div>
    <div *ngIf="data.option == 1 && data.id != -1" id="">
      <div style="
          width: 100%;
          padding: 10px;
          border: 1px dashed #efefef;
          margin-bottom: 10px;
        ">
        ¿Desea usted eliminar la OF <b>{{ data.clave }}</b>?<br />
        <b>NOTA: Esta operación es irreversible</b>
      </div>
    </div>
    <div *ngIf="data.option == 2">
      <div *ngIf="!ot_status_message; else plotlyProcesoElseBlock">
        <app-graphql-ts title="null" [graphConfig]="graphConfig"></app-graphql-ts>
      </div>
      <ng-template #plotlyProcesoElseBlock>
        <div align="center">
          {{ "PROCESS_STATUS.order_not_started_yet" | translate }}
        </div>
      </ng-template>
      <br />
      <button mat-raised-button color="primary" (click)="[updateOrderStatus(data), closeModal()]" [disabled]="
          data.status == 'ot_finished' || data.status == 'ot_validated'
        ">
        Cambiar estado a
        {{ "PROCESS_STATUS.".concat(data.new_status) | translate }}
      </button>
    </div>
    <div *ngIf="data.option == 3" id="of_docs">
      <div style="width: 100%; padding: 10px">
        <div class="upload-drop-zone" style="
            width: 100%;
            border: 1px dashed #efefef;
            padding: 10px;
            text-align: center;
            margin-bottom: 10px;
          ">
          <input id="singleFile" type="file" [fileUploadInputFor]="fileUploadQueue" />
        </div>
        <div [fileUploadInputFor]="fileUploadQueue" class="upload-drop-zone" style="
            width: 100%;
            border: 1px dashed #efefef;
            padding: 10px;
            text-align: center;
          ">
          <mat-icon aria-hidden="false" aria-label="Upload File" style="font-size: 50px">upload_file</mat-icon>
        </div>
        <div style="width: 100%; margin-bottom: 10px">
          <mat-file-upload-queue #fileUploadQueue [fileAlias]="'file'"
            [httpUrl]="'http://localhost:8180/jax-rs-jersey-application-sample'" multiple uploadAllLabel="Añadir"
            removeAllLabel="Eliminar">
            <mat-file-upload [file]="file" [id]="i" *ngFor="let file of fileUploadQueue.files; let i = index">
            </mat-file-upload>
          </mat-file-upload-queue>
        </div>
      </div>
      <table mat-table [dataSource]="data.datasource" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            ID
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ element.id }}
          </td>
        </ng-container>
        <ng-container matColumnDef="tipo">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            Tipo
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ element.tipo }}
          </td>
        </ng-container>
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            Nombre
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ element.nombre }}
          </td>
        </ng-container>
        <ng-container matColumnDef="fecha">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            Fecha
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ element.fecha }}
          </td>
        </ng-container>
        <ng-container matColumnDef="operario">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            Operario
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ element.operario }}
          </td>
        </ng-container>
        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            Acciones
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            <!-- <button mat-raised-button (click)="openDialog(element.id, 1)" color="warn" style="margin: 5px 2px">
              Eliminar
            </button>
            <button mat-raised-button (click)="openDialog(element.id, 1)" color="primary" style="margin: 5px 2px">
              Visualizar
            </button> -->
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="data.datasourceCols"></tr>
        <tr mat-row *matRowDef="let row; columns: data.datasourceCols"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Select page of periodic elements">
      </mat-paginator>
    </div>
    <div *ngIf="data.option == 4" id="of_comments">
      <div style="
          width: 100%;
          padding: 10px;
          border: 1px dashed #efefef;
          margin-bottom: 10px;
        ">
        <form [formGroup]="genericFormGroup">
          <div style="width: 20%; float: left; margin-right: 10px">
            <mat-form-field appearance="fill" style="width: 100%">
              <!-- TODO: Revisar -->
              <!-- <mat-select
                required
                [(value)]="selected"
                [(ngModel)]="genericTipo"
                placeholder="Tipo"
                formControlName="tipo"
              > -->
              <mat-select required [(value)]="selectedMaestro" [(ngModel)]="genericTipo" placeholder="Tipo"
                formControlName="tipo">
                <mat-option value="comentario" selected>Comentario</mat-option>
                <mat-option value="incidencia">Incidencia</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div style="width: 65%; float: left; margin-right: 10px">
            <mat-form-field appearance="fill" style="width: 100%">
              <mat-label>Comentario</mat-label>
              <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="25"
                formControlName="valor" [(ngModel)]="genericValor"
                style="white-space: pre-wrap; overflow-wrap: break-word"></textarea>
            </mat-form-field>
          </div>
          <div style="width: 10%; float: right">
            <button mat-raised-button [disabled]="genericValor == null" (click)="insertComentario()" color="primary"
              style="margin: 5px 2px">
              Añadir
            </button>
          </div>
          <div style="clear: both; height: 1px"></div>
        </form>
      </div>
      <table mat-table [dataSource]="data.datasource" class="mat-elevation-z8">
        <ng-container matColumnDef="tipo">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Tipo
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center; padding: 0 10px">
            {{ element.tipo }}
          </td>
        </ng-container>
        <ng-container matColumnDef="valor">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Valor
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: left; padding: 0 10px">
            <textarea readonly>
            {{ element.valor }}
          </textarea>
          </td>
        </ng-container>
        <ng-container matColumnDef="fecha">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Fecha
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center; padding: 0 10px">
            {{ element.fecha | getDatePipe }}
          </td>
        </ng-container>
        <ng-container matColumnDef="operario">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Operario
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center; padding: 0 10px">
            {{ element.usuario }}
          </td>
        </ng-container>
        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Acciones
          </th>
          <td mat-cell *matCellDef="let element; let i = index" style="text-align: center; padding: 0 10px">
            <button mat-raised-button (click)="deleteArrayElementFromDocument('', '', i, 'comentarios')" color="warn"
              style="margin: 5px 2px">
              Eliminar
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="data.datasourceCols"></tr>
        <tr mat-row *matRowDef="let row; columns: data.datasourceCols"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Select page of periodic elements">
      </mat-paginator>
    </div>
    <div *ngIf="data.option == 5" id="of_samples">
      <div style="
          width: 100%;
          padding: 10px;
          border: 1px dashed #efefef;
          margin-bottom: 10px;
        ">
        <form [formGroup]="genericFormGroup">
          <div style="width: 25%; float: left; margin-right: 10px">
            <mat-form-field appearance="fill" style="width: 100%">
              <mat-label>Unidad</mat-label>
              <input matInput type="text" value="HB" [(ngModel)]="genericTipo" formControlName="tipo" readonly />
            </mat-form-field>
          </div>
          <div style="width: 25%; float: left; margin-right: 10px">
            <mat-form-field appearance="fill" style="width: 100%">
              <mat-label>Valor</mat-label>
              <input matInput type="number" [(ngModel)]="genericValor" formControlName="valor" />
            </mat-form-field>
          </div>
          <div style="width: 10%; float: right">
            <button mat-raised-button [disabled]="genericValor == null" (click)="addMuestraToOf()" color="primary"
              style="margin: 5px 2px">
              Añadir
            </button>
          </div>
          <div style="clear: both; height: 1px"></div>
        </form>
      </div>
      <table mat-table [dataSource]="data.datasource" class="mat-elevation-z8">
        <ng-container matColumnDef="unidad">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Unidad
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center; padding: 0 10px">
            {{ element.unidad }}
          </td>
        </ng-container>
        <ng-container matColumnDef="valor">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Valor
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: left; padding: 0 10px">
            {{ element.valor }}
          </td>
        </ng-container>
        <ng-container matColumnDef="fecha">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Fecha
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center; padding: 0 10px">
            {{ element.fecha | getDatePipe }}
          </td>
        </ng-container>
        <ng-container matColumnDef="operario">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Operario
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center; padding: 0 10px">
            {{ element.usuario }}
          </td>
        </ng-container>
        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Acciones
          </th>
          <td mat-cell *matCellDef="let element; let i = index" style="text-align: center; padding: 0 10px">
            <button mat-raised-button (click)="deleteArrayElementFromDocument('', '', i, 'muestras')" color="warn"
              style="margin: 5px 2px">
              Eliminar
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="data.datasourceCols"></tr>
        <tr mat-row *matRowDef="let row; columns: data.datasourceCols"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Select page of periodic elements">
      </mat-paginator>
    </div>
    <div *ngIf="data.option == 6" id="of_trays">
      <div style="
          width: 100%;
          padding: 10px;
          border: 1px dashed #efefef;
          margin-bottom: 10px;
        ">
        <form [formGroup]="addNewBandejaForm">
          <div style="width: 25%; float: left; margin-right: 10px">
            <mat-form-field appearance="fill" style="width: 100%">
              <mat-select required [(ngModel)]="bandejasTipo" formControlName="tipo" placeholder="Bandeja">
                <mat-option value="Entrada 1">Entrada 1</mat-option>
                <mat-option value="Salida 1">Salida 1</mat-option>
                <mat-option value="Entrada 2">Entrada 2</mat-option>
                <mat-option value="Salida 2">Salida 2</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div style="width: 25%; float: left; margin-right: 10px">
            <mat-form-field appearance="fill" style="width: 100%">
              <mat-label>Cantidad</mat-label>
              <input matInput type="number" [(ngModel)]="bandejasCantidad" formControlName="cantidad" />
            </mat-form-field>
          </div>
          <!-- <div style="width: 25%; float: left; margin-right: 10px;">
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="picker" [(ngModel)]="bandejasFecha" formControlName="fecha">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div> -->
          <div style="width: 10%; float: right">
            <button mat-raised-button (click)="addBandejaToOF()" color="primary" style="margin: 5px 2px">
              Añadir
            </button>
          </div>
          <div style="clear: both; height: 1px"></div>
        </form>
      </div>
      <table mat-table [dataSource]="data.datasource" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            ID
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center; padding: 0 10px">
            {{ element.id }}
          </td>
        </ng-container>
        <ng-container matColumnDef="bandeja">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Bandeja
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center; padding: 0 10px">
            {{ element.tipo }}
          </td>
        </ng-container>
        <ng-container matColumnDef="valor">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Valor
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: left; padding: 0 10px">
            {{ element.cantidad }}
          </td>
        </ng-container>
        <ng-container matColumnDef="fecha">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Fecha
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center; padding: 0 10px">
            {{ element.fecha | getDatePipe }}
          </td>
        </ng-container>
        <ng-container matColumnDef="operario">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Operario
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center; padding: 0 10px">
            {{ element.usuario }}
          </td>
        </ng-container>
        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Acciones
          </th>
          <td mat-cell *matCellDef="let element; let i = index" style="text-align: center; padding: 0 10px">
            <button mat-raised-button (click)="deleteArrayElementFromDocument('', '', i, 'bandejas')" color="warn"
              style="margin: 5px 2px">
              Eliminar
            </button>
            <!-- <button mat-raised-button (click)="openDialog(element.id, 1)" color="primary" style="margin: 5px 2px;">Editar</button> -->
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="data.datasourceCols"></tr>
        <tr mat-row *matRowDef="let row; columns: data.datasourceCols"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Select page of periodic elements">
      </mat-paginator>
    </div>
    <div *ngIf="data.option == 8" id="of_alarms">
      <div style="
          width: 100%;
          padding: 10px;
          border: 1px dashed #efefef;
          margin-bottom: 10px;
        ">
        <div style="float: left; width: 50%">
          <plotly-plot [data]="data.bar_data.data" [layout]="data.bar_data.layout" [useResizeHandler]="true">
          </plotly-plot>
        </div>
        <div style="float: left; width: 50%">
          <plotly-plot [data]="data.pie_data.data" [layout]="data.pie_data.layout" [useResizeHandler]="true">
          </plotly-plot>
        </div>
        <div style="clear: both; height: 1px"></div>
      </div>
      <table mat-table [dataSource]="data.datasource" class="mat-elevation-z8">
        <ng-container matColumnDef="gunning">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Gunning
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center; padding: 0 10px">
            {{ element.gunning }}
          </td>
        </ng-container>
        <ng-container matColumnDef="alarma">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Alarma
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center; padding: 0 10px">
            {{ element.alarm }}
          </td>
        </ng-container>
        <ng-container matColumnDef="timestamp">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; padding: 0 10px">
            Fecha
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center; padding: 0 10px">
            {{ element.timestamp }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="data.datasourceCols"></tr>
        <tr mat-row *matRowDef="let row; columns: data.datasourceCols"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Select page of periodic elements">
      </mat-paginator>
    </div>
    <div *ngIf="data.option == 7" id="of_report">
      <div style="
          width: 100%;
          padding: 10px;
          border: 1px dashed #efefef;
          margin-bottom: 10px;
        ">
        <div style="width: 100%; border-bottom: 1px solid #ededed" id="report_header">
          <div style="
              background-color: #c0c0c0;
              width: 100%;
              text-align: center;
              padding: 5px;
            ">
            Datos
          </div>
          <div id="report_logo" style="float: left; width: 30%; padding: 5px; text-align: center">
            <img src="/assets/images/logo-legazpi.png" style="width: 100%" />
          </div>
          <div style="float: left; width: 35%; padding: 5px">
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Orden
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.orden }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Inicio
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.inicio | getDatePipe }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Fin
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.fin | getDatePipe }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Duración
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.order.duracion != "" && data.order.duracion != null
              ? (data.order.duracion / 60).toFixed(3)
              : "N/A"
              }}
              Hrs
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Colada
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.colada }}
            </div>
          </div>
          <div style="float: left; width: 35%; padding: 5px">
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Modelo
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.modelo.modelo }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Dispositivo
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.disp }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Piezas
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.order.piezas != "" && data.order.piezas != null
              ? data.order.piezas
              : 0
              }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Bandejas
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.traysTotal }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Kgs
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.order.kgs != "" && data.order.kgs != null
              ? data.order.kgs.toFixed(2)
              : 0
              }}
            </div>
          </div>
          <div style="clear: both; height: 1px"></div>
        </div>
        <div id="report_consigna">
          <div style="
              background-color: #c0c0c0;
              width: 100%;
              text-align: center;
              padding: 5px;
            ">
            Consigna
          </div>
          <div style="float: left; width: 45%; padding: 5px">
            <div style="
                width: 40%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Acero
            </div>
            <div style="
                width: 60%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.acero != "" && data.consigna.acero != null
              ? data.consigna.acero
              : "N/A"
              }}
            </div>
            <div style="
                width: 40%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Modelo
            </div>
            <div style="
                width: 60%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.modelo != "" && data.consigna.modelo != null
              ? data.consigna.modelo
              : "N/A"
              }}
            </div>
            <div style="
                width: 40%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Ciclo
            </div>
            <div style="
                width: 60%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.ciclo != "" && data.consigna.ciclo != null
              ? data.consigna.ciclo
              : "N/A"
              }}
            </div>
            <div style="
                width: 40%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Piezas (H6)
            </div>
            <div style="
                width: 60%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.piezas_ban_h6 != "" &&
              data.consigna.piezas_ban_h6 != null
              ? data.consigna.piezas_ban_h6
              : "N/A"
              }}
            </div>
            <div style="
                width: 40%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Piezas (H5)
            </div>
            <div style="
                width: 60%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.piezas_ban_h5 != "" &&
              data.consigna.piezas_ban_h5 != null
              ? data.consigna.piezas_ban_h5
              : "N/A"
              }}
            </div>
            <div style="
                width: 40%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Peso (Pieza)
            </div>
            <div style="
                width: 60%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.peso_pieza_df != "" &&
              data.consigna.peso_pieza_df != null
              ? data.consigna.peso_pieza_df
              : "N/A"
              }}
              Kgs
            </div>
          </div>
          <div style="float: left; width: 35%; padding: 5px">
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Tratamiento
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.tipo_recocido != "" &&
              data.consigna.tipo_recocido != null
              ? data.consigna.tipo_recocido
              : "N/A"
              }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Dur (Max)
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.limite_dureza_superior != "" &&
              data.consigna.limite_dureza_superior != null
              ? data.consigna.limite_dureza_superior
              : "N/A"
              }}
              {{ data.consigna.unidad }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Dur (Min)
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.limite_dureza_inferior != "" &&
              data.consigna.limite_dureza_inferior != null
              ? data.consigna.limite_dureza_inferior
              : "N/A"
              }}
              {{ data.consigna.unidad }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Enfr. 1
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.enfriamiento1 != "" &&
              data.consigna.enfriamiento1 != null
              ? data.consigna.enfriamiento1
              : "N/A"
              }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Enfr. 2
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.enfriamiento2 != "" &&
              data.consigna.enfriamiento2 != null
              ? data.consigna.enfriamiento2
              : "N/A"
              }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Enfr. RI
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.enfriamientoRI != "" &&
              data.consigna.enfriamientoRI != null
              ? data.consigna.enfriamientoRI
              : "N/A"
              }}
            </div>
          </div>
          <div style="float: left; width: 20%; padding: 5px">
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Escurrido
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.escurrido != "" && data.consigna.escurrido != null
              ? data.consigna.escurrido
              : "N/A"
              }}
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Tº 1
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.temperatura1 != "" &&
              data.consigna.temperatura1 != null
              ? data.consigna.temperatura1
              : "N/A"
              }}
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Tº 2
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.temperatura2 != "" &&
              data.consigna.temperatura2 != null
              ? data.consigna.temperatura2
              : "N/A"
              }}
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Tº Baño
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.temperatura_bano != "" &&
              data.consigna.temperatura_bano != null
              ? data.consigna.temperatura_bano
              : "N/A"
              }}
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Tº Agua
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.temperatura_agua_df != "" &&
              data.consigna.temperatura_agua_df != null
              ? data.consigna.temperatura_agua_df
              : "N/A"
              }}
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Lavado
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{
              data.consigna.tiempo_lav != "" &&
              data.consigna.tiempo_lav != null
              ? data.consigna.tiempo_lav
              : "N/A"
              }}
            </div>
          </div>
          <div style="clear: both; height: 1px"></div>
        </div>
        <div id="report_graph">
          <div style="
              background-color: #c0c0c0;
              width: 100%;
              text-align: center;
              padding: 5px;
            ">
            Gráfica de Temperaturas
          </div>
          <div style="width: 100%; padding: 5px">
            <!--
            <plotly-plot
              [data]="data.graph_data.data"
              [layout]="data.graph_data.layout"
              [useResizeHandler]="true">
            </plotly-plot>
            -->
            <div *ngIf="!ot_status_message; else plotlyProcesoElseBlock">
              <app-graphql-ts title="null" [graphConfig]="graphConfig"></app-graphql-ts>
            </div>
            <ng-template #plotlyProcesoElseBlock>
              <div align="center">
                {{ "PROCESS_STATUS.order_not_started_yet" | translate }}
              </div>
            </ng-template>
          </div>
        </div>
        <div id="report_samples">
          <div style="
              background-color: #c0c0c0;
              width: 100%;
              text-align: center;
              padding: 5px;
            ">
            Muestras
          </div>
          <div style="width: 100%; padding: 5px">
            <!--<div style="width: 25%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Muestra</div>-->
            <div style="
                width: 33%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Valor
            </div>
            <div style="
                width: 33%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Fecha
            </div>
            <div style="
                width: 33%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Operario
            </div>
            <div *ngFor="let item of data.samples">
              <!--<div style="width: 25%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed; background-color: #FFFFFF;">{{item.id}}</div>-->
              <div style="
                  width: 33%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.valor }} {{ item.unidad }}
              </div>
              <div style="
                  width: 33%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.fecha | getDatePipe }}
              </div>
              <div style="
                  width: 33%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.usuario }}
              </div>
            </div>
          </div>
          <div style="clear: both; height: 5px"></div>
          <!-- Cards -->
          <mat-card style="
              float: left;
              width: 32%;
              margin: 5px;
              background-color: #ededed;
            ">
            <mat-card-title style="padding: 10px 0 0 10px">Maximum</mat-card-title>
            <mat-card-subtitle style="padding: 0 0 0 10px">HB</mat-card-subtitle>
            <mat-card-content style="font-size: 24px; padding: 10px">{{
              data.sampleMax
              }}</mat-card-content>
          </mat-card>
          <mat-card style="
              float: left;
              width: 32%;
              margin: 5px;
              background-color: #ededed;
            ">
            <mat-card-title style="padding: 10px 0 0 10px">Minimum</mat-card-title>
            <mat-card-subtitle style="padding: 0 0 0 10px">HB</mat-card-subtitle>
            <mat-card-content style="font-size: 24px; padding: 10px">{{
              data.sampleMin
              }}</mat-card-content>
          </mat-card>
          <mat-card style="
              float: left;
              width: 32%;
              margin: 5px;
              background-color: #ededed;
            ">
            <mat-card-title style="padding: 10px 0 0 10px">Average</mat-card-title>
            <mat-card-subtitle style="padding: 0 0 0 10px">HB</mat-card-subtitle>
            <mat-card-content style="font-size: 24px; padding: 10px">{{
              data.sampleAvg
              }}</mat-card-content>
          </mat-card>
          <div style="clear: both; height: 5px"></div>
        </div>
        <div id="report_trays">
          <div style="
              background-color: #c0c0c0;
              width: 100%;
              text-align: center;
              padding: 5px;
            ">
            Bandejas
          </div>
          <div style="width: 100%; padding: 5px">
            <!--<div style="width: 20%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Id</div>-->
            <div style="
                width: 25%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Tipo
            </div>
            <div style="
                width: 25%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Valor
            </div>
            <div style="
                width: 25%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Fecha
            </div>
            <div style="
                width: 25%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Operario
            </div>
            <div *ngFor="let item of data.trays">
              <!--<div style="width: 20%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed; background-color: #FFFFFF;">{{item.id}}</div>-->
              <div style="
                  width: 25%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.tipo }}
              </div>
              <div style="
                  width: 25%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.cantidad }}
              </div>
              <div style="
                  width: 25%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.fecha | getDatePipe }}
              </div>
              <div style="
                  width: 25%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.usuario }}
              </div>
            </div>
          </div>
          <div style="clear: both; height: 5px"></div>
        </div>
        <div id="report_comments">
          <div style="
              background-color: #c0c0c0;
              width: 100%;
              text-align: center;
              padding: 5px;
            ">
            Comentarios
          </div>
          <div style="width: 100%; padding: 5px">
            <!--<div style="width: 20%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Id</div>-->
            <div style="
                width: 25%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Tipo
            </div>
            <div style="
                width: 25%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Valor
            </div>
            <div style="
                width: 25%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Fecha
            </div>
            <div style="
                width: 25%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Operario
            </div>
            <div *ngFor="let item of data.comments">
              <!--<div style="width: 25%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed; background-color: #FFFFFF;">{{item.id}}</div>-->
              <div style="
                  width: 25%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.tipo.toUpperCase() }}
              </div>
              <div style="
                  width: 25%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                <!--<button mat-raised-button matTooltip="{{item.valor}}" aria-label="Button that displays a tooltip when focused or hovered over">Ver</button>-->
                <!--<mat-icon aria-hidden="false" matTooltip="{{item.valor}}" aria-label="Comment" style="font-size: 14px; height: 14px; width: 14px;">sms</mat-icon>-->
                {{ item.valor }}
              </div>
              <div style="
                  width: 25%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.fecha | getDatePipe }}
              </div>
              <div style="
                  width: 25%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.usuario }}
              </div>
              <div style="clear: both"></div>
            </div>
          </div>
          <div style="clear: both; height: 5px"></div>
        </div>
        <!--
      <div style="width: 100%; border-top: 1px solid #ededed; text-align: right; padding: 10px;" id="report_footer">
        {{data.date}}
      </div>
      -->
      </div>
    </div>
    <div *ngIf="data.option == 15 && data.orders.length > 0" id="of_report_orders">
      <div style="
          width: 100%;
          padding: 10px;
          border: 1px dashed #efefef;
          margin-bottom: 10px;
        ">
        <div style="width: 100%; border-bottom: 1px solid #ededed" id="report_header">
          <div style="
              background-color: #c0c0c0;
              width: 100%;
              text-align: center;
              padding: 5px;
            ">
            Datos
          </div>
          <div id="report_logo" style="float: left; width: 30%; padding: 5px; text-align: center">
            <img src="/assets/images/logo-legazpi-report-global.png" style="width: 100%" />
          </div>
          <div style="float: left; width: 70%; padding: 5px">
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Ordenes (Total)
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.orders.length }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Inicio
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.inicio | getDatePipe }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Fin
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.fin | getDatePipe }}
            </div>
          </div>
          <div style="clear: both; height: 1px"></div>
        </div>
        <div id="report_operations">
          <div style="
              background-color: #c0c0c0;
              width: 100%;
              text-align: center;
              padding: 5px;
            ">
            Operaciones
          </div>
          <div style="width: 100%; padding: 5px; font-size: 12px">
            <div style="
                width: 5%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Orden
            </div>
            <div style="
                width: 5%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Colada
            </div>
            <div style="
                width: 5%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Clave
            </div>
            <div style="
                width: 5%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Bono
            </div>
            <div style="
                width: 5%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Horno
            </div>
            <div style="
                width: 7%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Inicio
            </div>
            <div style="
                width: 7%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Fin
            </div>
            <div style="
                width: 5%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Duración
            </div>
            <div style="
                width: 5%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Bandejas
            </div>
            <div style="
                width: 5%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Piezas
            </div>
            <div style="
                width: 5%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Kgs
            </div>
            <div style="
                width: 6%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Muestras
            </div>
            <div style="
                width: 5%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Modelo
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Consigna
            </div>
            <div style="clear: both"></div>
            <div *ngFor="let item of data.orders">
              <div style="
                  width: 5%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.orden }}<br /><br /><br />
              </div>
              <div style="
                  width: 5%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.colada }}<br /><br /><br />
              </div>
              <div style="
                  width: 5%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.clave }}<br /><br /><br />
              </div>
              <div style="
                  width: 5%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.bono }}<br /><br /><br />
              </div>
              <div style="
                  width: 5%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.disp }}<br /><br /><br />
              </div>
              <div style="
                  width: 7%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.inicio | getDatePipe }}<br /><br />
              </div>
              <div style="
                  width: 7%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.fin | getDatePipe }}<br /><br />
              </div>
              <div style="
                  width: 5%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{
                item.duracion != "" && item.duracion != null
                ? (item.duracion / 60).toFixed(2)
                : "N/A"
                }}
                Hrs<br /><br /><br />
              </div>
              <div style="
                  width: 5%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.bandejas }}<br /><br /><br />
              </div>
              <div style="
                  width: 5%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.piezas }}<br /><br /><br />
              </div>
              <div style="
                  width: 5%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.kgs != "" && item.kgs != null ? item.kgs.toFixed(2) : 0
                }}<br /><br /><br />
              </div>
              <div style="
                  width: 6%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                Min: {{ item.minDureza }}<br />
                Max: {{ item.maxDureza }}<br />Avg: {{ item.avgDureza }}
              </div>
              <div style="
                  width: 5%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                {{ item.modelo.modelo }}<br /><br /><br />
              </div>
              <div style="
                  width: 30%;
                  float: left;
                  text-align: left;
                  padding: 5px;
                  border-bottom: 1px solid #ededed;
                  background-color: #ffffff;
                ">
                <b>Acero:</b> {{ item.modelo.acero }} <b>Tratamiento:</b>
                {{ item.modelo.tipo_recocido }} <b>Ciclo:</b>
                {{ item.modelo.ciclo }} <b>T1C:</b>
                {{ item.modelo.temperatura2 }} <b>T2C:</b>
                {{ item.modelo.temperatura3 }} <b>E1C:</b>
                {{ item.modelo.enfriamiento2 }} <b>E2C:</b>
                {{ item.modelo.enfriamiento3 }} <b>TA:</b>
                {{ item.modelo.temperatura_agua }}<b>TB:</b>
                {{ item.modelo.tiempo_bano }} <b>TE:</b>
                {{ item.modelo.enfriamientoRI }}<br /><br />
              </div>
              <div style="clear: both"></div>
            </div>
          </div>
          <div style="clear: both; height: 5px"></div>
        </div>
      </div>
    </div>
    <div *ngIf="data.option == 15 && data.orders.length == 0" id="of_report_orders">
      <div style="
          width: 100%;
          padding: 10px;
          border: 1px dashed #efefef;
          margin-bottom: 10px;
        ">
        <div style="width: 100%; border-bottom: 1px solid #ededed" id="report_header">
          <div style="
              background-color: #c0c0c0;
              width: 100%;
              text-align: center;
              padding: 5px;
            ">
            Datos
          </div>
          <div id="report_logo" style="float: left; width: 30%; padding: 5px; text-align: center">
            <img src="/assets/images/logo-legazpi-report-global.png" style="width: 100%" />
          </div>
          <div style="float: left; width: 70%; padding: 5px">
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Ordenes (Total)
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.orders.length }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Inicio
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.inicio | getDatePipe }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Fin
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.fin | getDatePipe }}
            </div>
          </div>
          <div style="clear: both; height: 1px"></div>
        </div>
        <div id="report_operations">
          <div style="
              background-color: #c0c0c0;
              width: 100%;
              text-align: center;
              padding: 5px;
            ">
            Operaciones
          </div>
          <div style="width: 100%; padding: 5px">No data available</div>
        </div>
      </div>
    </div>
    <div *ngIf="data.option == 9" id="of_report">
      <div style="
          width: 100%;
          padding: 10px;
          border: 1px dashed #efefef;
          margin-bottom: 10px;
        ">
        <div style="width: 100%; border-bottom: 1px solid #ededed" id="report_header">
          <div style="
              background-color: #c0c0c0;
              width: 100%;
              text-align: center;
              padding: 5px;
            ">
            Datos
          </div>
          <div id="report_logo" style="float: left; width: 30%; padding: 5px">
            <img src="/assets/images/logo-magna.png" style="width: 92%" />
          </div>
          <div style="float: left; width: 35%; padding: 5px">
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Gunitado
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.gunning }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Inicio
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.start }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Fin
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.end }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Duración
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.duration }}
            </div>
          </div>
          <div style="float: left; width: 35%; padding: 5px">
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Campaña
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.campaign }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Tundish
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.tundish }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Producto
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.product }} kgs
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Agua
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.water }}
            </div>
          </div>
          <div style="clear: both; height: 1px"></div>
        </div>
        <div id="report_content">
          <div id="report_graph">
            <div style="
                background-color: #c0c0c0;
                width: 100%;
                text-align: center;
                padding: 5px;
              ">
              Producto
            </div>
            <div style="width: 50%; padding: 5px; float: left"></div>
            <div style="width: 50%; padding: 5px; float: left"></div>
            <div style="clear: both; height: 1px"></div>
            <div style="
                background-color: #c0c0c0;
                width: 100%;
                text-align: center;
                padding: 5px;
              ">
              Agua
            </div>
            <div style="width: 50%; padding: 5px; float: left"></div>
            <div style="width: 50%; padding: 5px; float: left"></div>
            <div style="clear: both; height: 1px"></div>
            <div style="
                background-color: #c0c0c0;
                width: 100%;
                text-align: center;
                padding: 5px;
              ">
              Alarmas
            </div>
            <div style="width: 50%; padding: 5px; float: left"></div>
            <div style="width: 50%; padding: 5px; float: left"></div>
            <div style="clear: both; height: 1px"></div>
          </div>
        </div>
        <!--
      <div style="width: 100%; border-top: 1px solid #ededed; text-align: right; padding: 10px;" id="report_footer">
        {{data.date}}
      </div>
      -->
      </div>
    </div>
    <div *ngIf="data.option == 10 || data.option == 11 || data.option == 12" id="of_op">
      <div style="width: 50%; float: left">
        <mat-card style="background-color: #ededed">
          <mat-card-title *ngIf="data.option == 10" style="padding: 20px 0 0 20px">Consigna Cantidad Arena
          </mat-card-title>
          <mat-card-title *ngIf="data.option == 11" style="padding: 20px 0 0 20px">Consigna Cantidad Silicato
          </mat-card-title>
          <mat-card-title *ngIf="data.option == 12" style="padding: 20px 0 0 20px">Consigna Cantidad Catalizador
          </mat-card-title>
          <mat-card-subtitle *ngIf="data.option == 10" style="padding: 0 0 0 20px">[kg/min]</mat-card-subtitle>
          <mat-card-subtitle *ngIf="data.option == 11 || data.option == 12" style="padding: 0 0 0 20px">[l/min]
          </mat-card-subtitle>
          <mat-card-content *ngIf="data.option == 10" style="font-size: 30px; padding: 0 0 20px 20px">72
          </mat-card-content>
          <mat-card-content *ngIf="data.option == 11" style="font-size: 30px; padding: 0 0 20px 20px">3.2
          </mat-card-content>
          <mat-card-content *ngIf="data.option == 12" style="font-size: 30px; padding: 0 0 20px 20px">0.4
          </mat-card-content>
        </mat-card>
      </div>
      <div style="width: 50%; float: left">
        <mat-card style="background-color: #ededed">
          <mat-card-title *ngIf="data.option == 10" style="padding: 20px 0 0 20px">Velocidad Dosificador Arena
          </mat-card-title>
          <mat-card-title *ngIf="data.option == 11" style="padding: 20px 0 0 20px">Velocidad Silicato</mat-card-title>
          <mat-card-title *ngIf="data.option == 12" style="padding: 20px 0 0 20px">Velocidad Catalizador
          </mat-card-title>
          <mat-card-subtitle *ngIf="data.option == 10" style="padding: 0 0 0 20px">[Hz]</mat-card-subtitle>
          <mat-card-subtitle *ngIf="data.option == 11 || data.option == 12" style="padding: 0 0 0 20px">[l/min]
          </mat-card-subtitle>
          <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px">0</mat-card-content>
        </mat-card>
      </div>
      <div style="clear: both; height: 10px"></div>
      <plotly-plot [data]="data.graph_data.data" [layout]="data.graph_data.layout" [useResizeHandler]="true">
      </plotly-plot>
      <plotly-plot [data]="data.graph_data.data" [layout]="data.graph_data.layout" [useResizeHandler]="true">
      </plotly-plot>
    </div>
    <div *ngIf="data.option == 13" id="of_report_tundish_op">
      <div style="
          width: 100%;
          padding: 10px;
          border: 1px dashed #efefef;
          margin-bottom: 10px;
        ">
        <div style="width: 100%; border-bottom: 1px solid #ededed" id="report_header">
          <div style="
              background-color: #c0c0c0;
              width: 100%;
              text-align: center;
              padding: 5px;
            ">
            Datos
          </div>
          <div id="report_logo" style="float: left; width: 30%; padding: 5px">
            <img src="/assets/images/logo-magna.png" style="width: 92%" />
          </div>
          <div style="float: left; width: 35%; padding: 5px">
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Operación
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.operation }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Inicio
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.start }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Fin
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.end }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Duración
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.duration }}
            </div>
          </div>
          <div style="float: left; width: 35%; padding: 5px">
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Campaña
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.campaign }}
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Arena
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.arena }} kgs
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Silicato
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.silicato }} lts
            </div>
            <div style="
                width: 30%;
                float: left;
                text-align: center;
                padding: 5px;
                background-color: #ededed;
                border-bottom: 1px solid #ededed;
              ">
              Catalizador
            </div>
            <div style="
                width: 70%;
                float: left;
                text-align: center;
                padding: 5px;
                border-bottom: 1px solid #ededed;
              ">
              {{ data.order.catalizador }} lts
            </div>
          </div>
          <div style="clear: both; height: 1px"></div>
        </div>
        <div id="report_content">
          <div id="report_graph">
            <div style="
                background-color: #c0c0c0;
                width: 100%;
                text-align: center;
                padding: 5px;
              ">
              Arena
            </div>
            <div style="width: 50%; padding: 5px; float: left">
              <mat-card style="background-color: #ededed">
                <mat-card-title style="padding: 20px 0 0 20px">Consigna Cantidad Arena</mat-card-title>
                <mat-card-subtitle style="padding: 0 0 0 20px">[kg/min]</mat-card-subtitle>
                <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px">72</mat-card-content>
              </mat-card>
            </div>
            <div style="width: 50%; padding: 5px; float: left">
              <mat-card style="background-color: #ededed">
                <mat-card-title style="padding: 20px 0 0 20px">Velocidad Dosificador Arena</mat-card-title>
                <mat-card-subtitle style="padding: 0 0 0 20px">[Hz]</mat-card-subtitle>
                <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px">0</mat-card-content>
              </mat-card>
            </div>
            <div style="clear: both; height: 1px"></div>
            <plotly-plot [data]="data.graph_data.data" [layout]="data.graph_data.layout" [useResizeHandler]="true">
            </plotly-plot>
            <plotly-plot [data]="data.graph_data.data" [layout]="data.graph_data.layout" [useResizeHandler]="true">
            </plotly-plot>
            <div style="
                background-color: #c0c0c0;
                width: 100%;
                text-align: center;
                padding: 5px;
              ">
              Silicato
            </div>
            <div style="width: 50%; padding: 5px; float: left">
              <mat-card style="background-color: #ededed">
                <mat-card-title style="padding: 20px 0 0 20px">Consigna Cantidad Silicato</mat-card-title>
                <mat-card-subtitle style="padding: 0 0 0 20px">[l/min]</mat-card-subtitle>
                <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px">3.2</mat-card-content>
              </mat-card>
            </div>
            <div style="width: 50%; padding: 5px; float: left">
              <mat-card style="background-color: #ededed">
                <mat-card-title style="padding: 20px 0 0 20px">Velocidad Silicato</mat-card-title>
                <mat-card-subtitle style="padding: 0 0 0 20px">[l/min]</mat-card-subtitle>
                <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px">0</mat-card-content>
              </mat-card>
            </div>
            <div style="clear: both; height: 1px"></div>
            <plotly-plot [data]="data.graph_data.data" [layout]="data.graph_data.layout" [useResizeHandler]="true">
            </plotly-plot>
            <plotly-plot [data]="data.graph_data.data" [layout]="data.graph_data.layout" [useResizeHandler]="true">
            </plotly-plot>
            <div style="clear: both; height: 1px"></div>
            <div style="
                background-color: #c0c0c0;
                width: 100%;
                text-align: center;
                padding: 5px;
              ">
              Catalizador
            </div>
            <div style="width: 50%; padding: 5px; float: left">
              <mat-card style="background-color: #ededed">
                <mat-card-title style="padding: 20px 0 0 20px">Consigna Cantidad Catalizador</mat-card-title>
                <mat-card-subtitle style="padding: 0 0 0 20px">[l/min]</mat-card-subtitle>
                <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px">0.4</mat-card-content>
              </mat-card>
            </div>
            <div style="width: 50%; padding: 5px; float: left">
              <mat-card style="background-color: #ededed">
                <mat-card-title style="padding: 20px 0 0 20px">Velocidad Catalizador</mat-card-title>
                <mat-card-subtitle style="padding: 0 0 0 20px">[l/min]</mat-card-subtitle>
                <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px">0</mat-card-content>
              </mat-card>
            </div>
            <div style="clear: both; height: 1px"></div>
            <plotly-plot [data]="data.graph_data.data" [layout]="data.graph_data.layout" [useResizeHandler]="true">
            </plotly-plot>
            <plotly-plot [data]="data.graph_data.data" [layout]="data.graph_data.layout" [useResizeHandler]="true">
            </plotly-plot>
            <div style="clear: both; height: 1px"></div>
            <div style="
                background-color: #c0c0c0;
                width: 100%;
                text-align: center;
                padding: 5px;
              ">
              Alarmas
            </div>
            <div style="width: 100%; padding: 5px">
              <div style="
                  width: 50%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  background-color: #ededed;
                  border-bottom: 1px solid #ededed;
                ">
                Fecha
              </div>
              <div style="
                  width: 50%;
                  float: left;
                  text-align: center;
                  padding: 5px;
                  background-color: #ededed;
                  border-bottom: 1px solid #ededed;
                ">
                Alarma
              </div>
              <div *ngFor="let item of data.alarms">
                <div style="
                    width: 50%;
                    float: left;
                    text-align: center;
                    padding: 5px;
                    border-bottom: 1px solid #ededed;
                    background-color: #ffffff;
                  ">
                  {{ item.timestamp }}
                </div>
                <div style="
                    width: 50%;
                    float: left;
                    text-align: center;
                    padding: 5px;
                    border-bottom: 1px solid #ededed;
                    background-color: #ffffff;
                  ">
                  {{ item.alarm }}
                </div>
              </div>
            </div>
            <div style="clear: both; height: 1px"></div>
          </div>
        </div>
        <!--
      <div style="width: 100%; border-top: 1px solid #ededed; text-align: right; padding: 10px;" id="report_footer">
        {{data.date}}
      </div>
      -->
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button *ngIf="data.option == 7" mat-raised-button color="primary" (click)="doPrintOperationReport(0)"
      [disabled]="!isPrintEnabled">
      Imprimir
    </button>
    <button *ngIf="data.option == -1 && data.id == -1" mat-raised-button mat-dialog-close color="primary"
      (click)="doAddCampaign(data.type, data.id)">
      Añadir
    </button>
    <button *ngIf="data.option == 0" mat-raised-button mat-dialog-close color="primary"
      (click)="doEditCampaign(data.type, data.id)">
      Editar
    </button>
    <button *ngIf="data.option == 1" mat-raised-button mat-dialog-close color="warn"
      (click)="doRemoveCampaign(data.type, data.id, data.row)">
      Eliminar
    </button>
    <button *ngIf="data.option == 15 && data.orders.length > 0" mat-raised-button color="primary"
      (click)="doPrintOperationReport(1)" [disabled]="false">
      Imprimir
    </button>
    <button mat-raised-button color="primary" (click)="onNoClick()">
      Cerrar
    </button>
  </mat-dialog-actions>
</div>